import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { showDialogOverlay, hideDialogOverlay } from "../../../utils/dialogOverlay.js";
import { renderKisilerGrid } from "../kisilerGrid.js";
import { uiState } from "../../../state/uiState.js";
import { truncateLabel } from "../../../utils/textPresentation.js";

const API = "/api";
let didBind = false;

function ensureKisilerEditDialog() {
	if (document.getElementById("kisilerEditDialog")) return;
	document.body.insertAdjacentHTML("beforeend", `
<dialog id="kisilerEditDialog">
    <div class="edit-loading-overlay" hidden>
        <div class="edit-loading-spinner"></div>
        <span class="edit-loading-text">Y\u00fckleniyor...</span>
    </div>
    <form method="dialog" novalidate class="create-dialog-container">
        <div class="create-dialog-header">
            <h4>Ki\u015fi D\u00fczenle</h4>
        </div>
        <div class="create-dialog-content">
            <div class="kisi-bilgiler section">
                <div class="section-1-header"><h5>Ki\u015fi Bilgileri</h5></div>
                <div class="section-1-content">
                    <div class="column-container kisiler-tc">
                        <label style="pointer-events:none;">T.C. Kimlik No</label>
                        <div class="kisiler-tc-readonly">
                            <span class="kisiler-edit-tc-value kisiler-tc-readonly-deger"></span>
                        </div>
                    </div>
                    <div class="column-container kisiler-ad">
                        <label for="edit_kisiler_first_name">Ad:</label>
                        <input id="edit_kisiler_first_name" class="form-input" type="text" name="first_name" maxlength="100" placeholder="Ki\u015finin ad\u0131n\u0131 giriniz" required />
                        <span class="info" data-focus="Ki\u015finin ad\u0131n\u0131 girin." data-invalid="Sadece harf, bo\u015fluk veya tire girebilirsiniz."></span>
                    </div>
                    <div class="column-container kisiler-soyad">
                        <label for="edit_kisiler_last_name">Soyad:</label>
                        <input id="edit_kisiler_last_name" class="form-input" type="text" name="last_name" maxlength="100" placeholder="Ki\u015finin soyad\u0131n\u0131 giriniz" required />
                        <span class="info" data-focus="Ki\u015finin soyad\u0131n\u0131 girin." data-invalid="Sadece harf, bo\u015fluk veya tire girebilirsiniz."></span>
                    </div>
                    <div class="column-container kisiler-departman">
                        <label for="edit_kisiler_departman">Departman:</label>
                        <select id="edit_kisiler_departman" class="form-select" name="kisi_departman_id" required>
                            <option value="" selected>Departman se\u00e7iniz</option>
                        </select>
                        <span class="info" data-focus="Departman se\u00e7iniz." data-invalid="Ge\u00e7erli bir departman se\u00e7melisiniz."></span>
                    </div>
                    <div class="column-container kisiler-unvan">
                        <label for="edit_kisiler_unvan">\u00dcnvan:</label>
                        <select id="edit_kisiler_unvan" class="form-select" name="unvan_id" required>
                            <option value="" selected>\u00dcnvan se\u00e7iniz</option>
                        </select>
                        <span class="info" data-focus="\u00dcnvan se\u00e7iniz." data-invalid="\u00dcnvan se\u00e7melisiniz."></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="create-dialog-buttons">
            <button type="button" class="edit-cancel">\u0130ptal</button>
            <button type="submit" class="create-save">Kaydet</button>
        </div>
    </form>
</dialog>`);
}

export function initKisilerEditDialog() {
	ensureKisilerEditDialog();
	const dialog = document.querySelector("#kisilerEditDialog");
	if (!dialog || didBind) return;
	didBind = true;

	const form = dialog.querySelector("form");

	document.body.addEventListener("click", (e) => {
		if (e.target.closest(".edit-cancel") && dialog.open) dialog.close();
	});

	dialog.addEventListener("close", () => {
		delete dialog.dataset.submitted;
		delete dialog.dataset.tc;
		form?.reset();
		const tcSpan = dialog.querySelector(".kisiler-edit-tc-value");
		if (tcSpan) tcSpan.textContent = "";
	});

	if (form && !form._bound) {
		form._bound = true;
		form.addEventListener("submit", async (e) => {
			e.preventDefault();
			dialog.dataset.submitted = "true";

			if (!form.checkValidity()) {
				showToast("L\u00fctfen t\u00fcm zorunlu alanlar\u0131 doldurunuz.", "error");
				form.querySelector(":invalid")?.scrollIntoView({ behavior: "smooth", block: "center" });
				return;
			}

			const tc = dialog.dataset.tc;
			const first_name = form.querySelector("[name=first_name]").value.trim();
			const last_name = form.querySelector("[name=last_name]").value.trim();
			const kisi_departman_id = form.querySelector("[name=kisi_departman_id]").value;
			const unvan_id = form.querySelector("[name=unvan_id]").value || null;

			showDialogOverlay(dialog);
			await new Promise((r) => setTimeout(r, 350));
			try {
				const res = await fetch(`${API}/kisiler/${encodeURIComponent(tc)}`, {
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ first_name, last_name, kisi_departman_id, unvan_id }),
				});
				const data = await res.json();
				if (!data.ok) {
					showToast(data.error || "G\u00fcncelleme s\u0131ras\u0131nda hata olu\u015ftu.", "error");
					return;
				}
				showToast("Ki\u015fi ba\u015far\u0131yla g\u00fcncellendi.", "success", false);
				dialog.close();
				const refreshUrl = uiState.kisiler.lastSearchUrl ?? `${API}/kisiler`;
				renderKisilerGrid({ url: refreshUrl, paginationLimit: uiState.kisiler.paginationLimit });
			} catch (err) {
				console.error("PUT /kisiler hatasi:", err);
				showToast("Sunucuya ba\u011flan\u0131lamad\u0131.", "error");
			} finally {
				hideDialogOverlay();
			}
		});
	}

	window.openKisilerEditDialog = async (tc) => {
		const d = document.querySelector("#kisilerEditDialog");
		const f = d.querySelector("form");

		delete d.dataset.submitted;
		f?.reset();
		d.querySelector(".kisiler-edit-tc-value").textContent = tc;
		d.dataset.tc = tc;

		d.showModal();
		showDialogOverlay(d, "Y\u00fckleniyor...");
		await new Promise((r) => setTimeout(r, 350));
		try {
			const [kisiData, departmanData, unvanData] = await Promise.all([
				fetch(`${API}/kisiler/${encodeURIComponent(tc)}`).then((r) => r.json()),
				fetch(`${API}/kisi-departmanlari`).then((r) => r.json()),
				fetch(`${API}/unvanlar`).then((r) => r.json()),
			]);

			const departmanSel = d.querySelector("#edit_kisiler_departman");
			departmanSel.innerHTML = '<option value="" selected>Departman se\u00e7iniz</option>';
			(departmanData.items || []).forEach((item) => {
				const fullLabel = String(item.name ?? "");
				const opt = document.createElement("option");
				opt.value = item.id;
				opt.textContent = truncateLabel(fullLabel, 32);
				opt.title = fullLabel;
				departmanSel.appendChild(opt);
			});

			const unvanSel = d.querySelector("#edit_kisiler_unvan");
			unvanSel.innerHTML = '<option value="">\u2014 Se\u00e7iniz (opsiyonel) \u2014</option>';
			(unvanData.items || []).forEach((item) => {
				const fullLabel = String(item.name ?? "");
				const opt = document.createElement("option");
				opt.value = item.id;
				opt.textContent = truncateLabel(fullLabel, 32);
				opt.title = fullLabel;
				unvanSel.appendChild(opt);
			});

			d.querySelector("#edit_kisiler_first_name").value = kisiData.first_name ?? "";
			d.querySelector("#edit_kisiler_last_name").value = kisiData.last_name ?? "";
			departmanSel.value = String(kisiData.kisi_departman_id ?? "");
			unvanSel.value = String(kisiData.unvan_id ?? "");
		} catch (err) {
			console.error("Kisi duzenleme verisi yuklenemedi:", err);
		} finally {
			hideDialogOverlay();
		}
	};
}

function showToast(message, type = "success", inDialog = true) {
	Toastify({
		text: message,
		duration: 3000,
		gravity: "top",
		position: "right",
		stopOnFocus: true,
		selector: inDialog ? document.querySelector("#kisilerEditDialog") : document.body,
		style: {
			background: type === "success" ? "#22c55e" : "#ee4447",
			borderRadius: "8px",
			fontSize: "14px",
			fontWeight: "500",
		},
	}).showToast();
}
